// src/components/UserActionMenu.jsx

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import GavelOutlined from "@mui/icons-material/GavelOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import LockResetIcon from "@mui/icons-material/LockReset";

const UserActionsMenu = ({ user, onEdit, onIssueFine, onMember360, onResetPassword }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const roleGroupId = Number(localStorage.getItem("roleGroupId"));
  const canManage = roleGroupId === 1 || roleGroupId === 2;
  const hasRoleContext = Number.isFinite(roleGroupId) && roleGroupId > 0;
  const canShowResetPassword = hasRoleContext ? canManage : true;

  return (
    <>
      <IconButton onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            handleClose();
            onEdit?.();
          }}
        >
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Edit</ListItemText>
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleClose();
            alert("Activate not yet implemented.");
          }}
        >
          <ListItemIcon>
            <CheckCircleOutlineIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Activate</ListItemText>
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleClose();
            navigate(`/contributions/user/${user.id}`, { state: { firstName: user.firstName } });
          }}
        >
          <ListItemIcon>
            <ReceiptLongIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>View Contribution Schedule</ListItemText>
        </MenuItem>


        <MenuItem
          onClick={() => {
            handleClose();
            onMember360?.();
          }}
        >
          <ListItemIcon>
            <InsightsOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Member 360</ListItemText>
        </MenuItem>

        {canShowResetPassword ? (
          <MenuItem
            onClick={() => {
              handleClose();
              onResetPassword?.();
            }}
          >
            <ListItemIcon>
              <LockResetIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Reset Password</ListItemText>
          </MenuItem>
        ) : null}

        <Tooltip title={canManage ? "" : "You are not authorized to issue fines."}>
          <span>
            <MenuItem
              onClick={() => {
                if (!canManage) return;
                handleClose();
                onIssueFine?.();
              }}
              disabled={!canManage}
            >
              <ListItemIcon>
                <GavelOutlined fontSize="small" />
              </ListItemIcon>
              <ListItemText>Issue Fine</ListItemText>
            </MenuItem>
          </span>
        </Tooltip>
      </Menu>
    </>
  );
};

export default UserActionsMenu;
